import { ActionIcon, Box, FileButton, Image, Tooltip } from "@mantine/core";
import { IconPhoto, IconX } from "@tabler/icons-react";
import type { JSX } from "react";
import classes from "./ImageInput.module.css";

interface Props {
    value?: File | null;
    onChange: (file: File | null) => void;
    disabled?: boolean;
}

function ImageInput({ value = null, onChange, disabled }: Props): JSX.Element {
    const previewUrl = value ? URL.createObjectURL(value) : null;

    if (previewUrl) {
        return (
            <Box className={classes.previewContainer}>
                <Image src={previewUrl} radius="sm" fit="contain" h={36} w="auto" />
                <ActionIcon
                    className={classes.removeButton}
                    size="xs"
                    variant="filled"
                    color="red"
                    onClick={() => onChange(null)}
                    disabled={disabled}
                >
                    <IconX size={10} />
                </ActionIcon>
            </Box>
        );
    }

    return (
        <Tooltip label="Add reference image">
            <FileButton onChange={onChange} accept="image/png,image/jpeg,image/webp" disabled={disabled}>
                {(props) => (
                    <ActionIcon {...props} variant="default" size="lg">
                        <IconPhoto size={18} />
                    </ActionIcon>
                )}
            </FileButton>
        </Tooltip>
    );
}

export async function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result as string;
            resolve(result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export default ImageInput;
